import "./basic-card.scss";

export default {
  /** class for div that wraps body */
  body: "basic-card-body",
  /** class for the button itself */
  button: "ssg-forms-btn basic-card-button",
  /** class for div wrapper around button */
  buttonWrapper: "basic-card-button-wrapper",
  /** class for root div */
  cardWrapper: "basic-card",
  /** class for div wrapping title and body */
  content: "basic-card-content",
  /** class for the card header */
  header: "basic-card-header",
  /** class for the card header's text */
  headerText: "basic-card-header-text",
  /** class for content title div */
  title: "basic-card-title",
}



// WEBPACK FOOTER //
// src/common/widgets/basic-card.style.js